import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { MachineRouteService } from '../machine-route.service';
import { SettingsHttpService, PriceChangeData, Recipe, UpdatePriceChangeRequest } from '../../../../../app/core/settings';
import { Observable, of } from 'rxjs';
import { ChangeDetectionStrategy } from '@angular/compiler/src/core';
import { MixpanelService } from '../../../../../app/services/mixpanel.service';
import { PricingTemplateId, PRICING_TEMPLATES, PRICING_TEMPLATE_LABELS } from './pricing-templates.constants';

@Component({
  selector: 'kt-price-change',
  templateUrl: './price-change.component.html',
  styleUrls: ['./price-change.component.scss']
})
export class PriceChangeComponent implements OnInit {

	selectedMachine: any;
	machineId: string;
	serial_no: string;

	rawRecipes = '';
	_recipes: Recipe[] | null = null;
	_allRecipes: Recipe[] | null = null; // Store all recipes including hot water
	// priceChange: any = {}
	// priceloading = false;
	priceChangeObservable$: Observable<PriceChangeData>;
	appliedPricingTemplate: PricingTemplateId | null = null;


	priceChange: PriceChangeData = {
		machine_id: "",
		updated_by: " ",
		updated_at: " ",
		applied_at: null,
		recipes: [{
			recipeId:  "",
			name: "",
			oldPrice: 0,
			price: null
		}]

	};

	// trackByIndex(index: number, item: any) {
	// 	return index;
	//   }


	// priceChange = {
	// 	machine_id: "",
	// 	updated_by: "Karthik@bluesparq.com",
	// 	updated_at: "2023-09-11T10:23:45Z",
	// 	applied_at: "2023-09-11T11:05:45Z",
	// 	recipes: [
	// 		{
	// 			name: 'Americano',
	// 			recipeId: '',
	// 			oldPrice: 3.49,
	// 			price: 2
	// 		},
	// 		{
	// 			name: 'Mocha',
	// 			recipeId: '',
	// 			oldPrice: 3.49,
	// 			price: 2
	// 		}
	// 	]
	// };

// 	machine_id,name,recipeId,oldPrice,price
// machine_id,updated_by,updated_at,applied_at

  constructor(private location: Location, private http: SettingsHttpService, private _snackBar: MatSnackBar,
	private cdr: ChangeDetectorRef, private mixpanelService: MixpanelService, private route: ActivatedRoute, private machineRouteService: MachineRouteService) {}

  ngOnInit() {
	this.selectedMachine = this.machineRouteService.getMachine(this.route);
	if (!this.selectedMachine) return;
	this.machineId = this.selectedMachine.machine_id;
	this.serial_no = this.selectedMachine.serial_no;
	this.getPriceChange();

	this.mixpanelService.track(this.mixpanelService.PAGE_VIEW, {
		machineName: this.selectedMachine.machine_name,
		machineId: this.selectedMachine.machine_id,
		serialNo: this.selectedMachine.serial_no
	});
  }

  onBack(){
	this.location.back();
	// this.priceChange.recipes[0].price = 5;
  }

  get appliedTemplateLabel(): string {
	return this.appliedPricingTemplate ? PRICING_TEMPLATE_LABELS[this.appliedPricingTemplate] : '';
  }

  applyPricingTemplate(templateId: PricingTemplateId) {
	if (!this._recipes) {
		return;
	}

	const prices = PRICING_TEMPLATES[templateId];
	this._recipes.forEach(item => {
		if (prices[item.name] != null) {
			item.price = prices[item.name];
		}
	});
	this.appliedPricingTemplate = templateId;
	this.cdr.detectChanges();
  }

  clearPrices() {
	if (!this._recipes) {
		return;
	}

	this._recipes.forEach(item => item.price = null);
	this.appliedPricingTemplate = null;
	this.cdr.detectChanges();
  }

  getPriceChange(){
	// this.priceloading = true;
	this.priceChangeObservable$ = this.http.getPriceChange(this.machineId);
	// this.http.getPriceChange(this.machineId)
	this.priceChangeObservable$.subscribe(priceChange => {
		if(priceChange && priceChange.recipes){
			this._allRecipes = priceChange.recipes; // Store all recipes
			// Filter out hot water for display
			this._recipes = priceChange.recipes.filter(item => {
				const name = (item.name || '').toLowerCase().trim();
				return name !== 'hot water';
			});
			// Store raw recipes without hot water for change detection
			this.rawRecipes = JSON.stringify(this._recipes);
			this.priceChange = priceChange;
			this.cdr.detectChanges();
			// this.priceloading = false;
		}
	});
  }


	onSubmit() {
	// Check if any of the new prices are empty
// <<<<<<< Updated upstream
// 	// const hasEmptyPrice = this._recipes.some(item => !item.price);
// 	const hasEmptyPrice = this._recipes.some(item => !item.price.trim());

// =======
	// const hasEmptyPrice = this._recipes.some(item => !(item.price.toString().trim()) || isNaN(item.price));
// >>>>>>> Stashed changes
	const hasEmptyPrice = this._recipes.some(item => {
		if (item.price == null || item.price == undefined) {
			return true;
		}
		const priceString = item.price.toString().trim();
		return priceString === '' || isNaN(item.price);
	});

	if (hasEmptyPrice) {
	  // Show a snackbar message if there is an empty price
	  this.showSnackBar('Price cannot be empty', 3000);
	  return;
	}

	// If no empty prices, proceed with submitting the data
	if (JSON.stringify(this._recipes) !== this.rawRecipes) {
	  // Get original hot water recipe (if it exists)
	  const hotWaterRecipe = this._allRecipes && this._allRecipes.find(item => {
		const name = (item.name || '').toLowerCase().trim();
		return name === 'hot water';
	  });

	  // Merge visible recipes with hot water (preserving its original value)
	  const recipesToSubmit = this._recipes.slice();
	  if (hotWaterRecipe) {
		recipesToSubmit.push(hotWaterRecipe);
	  }

	  const updateRequest: UpdatePriceChangeRequest = {
		machine_id: this.priceChange.machine_id,
		serial_no: this.serial_no,
		updated_by: this.priceChange.updated_by,
		updated_at: this.priceChange.updated_at,
		applied_at: this.priceChange.applied_at,
		recipes: recipesToSubmit
	  };

	  this.http.updateMenuPrices(updateRequest).subscribe(result => {
		// Update the UI with the result from the API
		if (result && result.recipes) {
			this._allRecipes = result.recipes; // Store all recipes
			// Filter out hot water for display
			this._recipes = result.recipes.filter(item => {
				const name = (item.name || '').toLowerCase().trim();
				return name !== 'hot water';
			});
			// Store raw recipes without hot water for change detection
			this.rawRecipes = JSON.stringify(this._recipes);
			this.priceChange = result;
			// Update the observable so the template refreshes
			this.priceChangeObservable$ = of(result);
			this.cdr.detectChanges();
			this.showSnackBar('Prices updated successfully', 3000);
		}
	  }, error => {
		// Handle error if needed
		console.error('Error updating prices:', error);
		this.showSnackBar('Failed to update prices', 3000);
	  });
	//   console.log(this.priceChange.recipes);
	} else {
		this.showSnackBar("No Changes were made.", 3000);
	}
  }


  showSnackBar(message: string, duration: number) {
	let snackRef = this._snackBar.open(message, 'close');
	if (duration > 0) {
		setTimeout(() => {
			this._snackBar.dismiss();
		}, duration);
	}

	snackRef.onAction().subscribe(() => {
		this._snackBar.dismiss();
	});
}

}
